import React from "react";
import { withTranslation } from 'react-i18next';
import { Button, OverlayTrigger, Popover } from 'react-bootstrap';

import iconoMapaBlanco from '../../images/btn_filtros/map_btn_blanco.png'
import mapaTerrain from '../../images/btn_filtros/terrain_mapa.png'
import mapaSatelite from '../../images/btn_filtros/satelite_mapa.png'

import i18next from 'i18next';

class MapSelector extends React.Component {


    shouldComponentUpdate(nextProps, nextState){
        if (nextProps.mapType !== this.props.mapType) {
            return true
        }
        return false
    }

    handleChangeMapType = (e) => {
        document.body.click()
        this.props.handleChangeMapType(e.target.value)
    }

    componentDidMount(){
        i18next.on('languageChanged', () => {this.forceUpdate()})
    }

    render() {

        const { t } = this.props

        return (
            <div className="marco_btn float-right mt-1 mr-1" style={{ backgroundColor: "#000" }}>
                <OverlayTrigger
                    trigger="click"
                    key={'mapSelect_popover'}
                    placement={'bottom'}
                    rootClose
                    overlay={
                        <Popover style={{maxWidth: 400, width: 'auto', minWidth: 400}}>
                          <Popover.Content >
                            {this.renderSelectorContent()}
                          </Popover.Content>
                        </Popover>
                    }>
                        <Button variant="dark" size="sm" className="btn-visor m-1 float-right"><img className="pb-1 mr-2" src={iconoMapaBlanco} alt="icono buscador" />{t("mapa")}</Button>
                </OverlayTrigger>
            </div>
        )
    }

    renderSelectorContent = () => {

        const { t } = this.props

        return (
                <div>
                    <div className="row"  style={{ display: "flex" }}>
                        <div className="col-2 form-check" style={{ textAlign: "right" }}>
                            <label className="form-check-label" htmlFor="mapas">
                                <img width="100%" className="" src={mapaTerrain} alt="mapaTerrain" />
                            </label>
                        </div>
                        <div className="col-4 pt-2 form-check">
                            <input onChange={this.handleChangeMapType} className="form-check-input" type="radio" id="mapas" name="layerMap" value="MAP" checked={this.props.mapType === "MAP"} />
                            <label className="form-check-label" htmlFor="mapas">
                                {t("mapa")}
                            </label>
                        </div>
                        <div className="col-2 form-check" style={{ textAlign: "right" }}>
                            <label className="form-check-label" htmlFor="satel">
                                <img width="100%" className="" src={mapaSatelite} alt="mapaTerrain" />
                            </label>
                        </div>
                        <div className="col-4 pt-2 form-check">
                            <input onChange={this.handleChangeMapType} className="form-check-input" type="radio" id="satel" name="layerMap" value="SATELITE" checked={this.props.mapType === "SATELITE"}/>
                            <label className="form-check-label" htmlFor="satel">
                                {t("mapa-satelite")}
                            </label>
                        </div>
                    </div>
                </div>
        )
    }
}

export default withTranslation()(MapSelector)
